export default "__VITE_ASSET__Cm$Cy2iC__"